import { cn } from "@/lib/cn";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  tone?: "light" | "dark";
};

export default function IconButton({
  label,
  tone = "light",
  className,
  children,
  ...rest
}: Props) {
  return (
    <button
      type="button"
      aria-label={label}
      className={cn(
        "inline-flex h-10 w-10 items-center justify-center rounded-[var(--radius-pill)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)]",
        tone === "light"
          ? "text-[color:var(--color-text)] hover:bg-[color:var(--color-surface-alt)]"
          : "text-[color:var(--color-bg)] hover:bg-white/10",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
